<app-critterpedia-detail [aid]="aid"></app-critterpedia-detail>

